<template>
    <div class="p-0 pt-5 mt-5 col-md-8 mx-auto">
        <v-row class="mt-5">
            <v-col cols="12" md="6">
                <v-text-field
                        v-model="title"
                        label="عنوان تاریخچه"
                        required
                        dense
                        outlined
                        class="mt-1"
                        prepend-inner-icon="fa fa-pencil-alt"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                        v-model="step"
                        label="مرحله"
                        required
                        dense
                        outlined
                        class="mt-1"
                        prepend-inner-icon="fa fa-pencil-alt"
                ></v-text-field>

            </v-col>
            <v-col cols="12" md="12">
                <date-picker v-model="created_at" type="datetime"
                             format="YYYY-MM-DD HH:mm"
                             display-format="jYYYY-jMM-jDD HH:mm"
                             :timezone="false"
                             auto-submit
                             label="زمان آخرین تماس"
                             endTime></date-picker>
            </v-col>

            <v-col cols="12" md="12">
                <p>مذاکرات انجام شده :</p>
                <ckeditor :editor="editor" v-model="description" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" md="12">
                <date-picker v-model="time" type="datetime"
                             format="YYYY-MM-DD HH:mm"
                             display-format="jYYYY-jMM-jDD HH:mm"
                             :timezone="false"
                             auto-submit
                             label="زمان یادآوری"
                             endTime></date-picker>
            </v-col>
            <v-col cols="12" md="12">
                <p>موارد پیگیری در تماس بعدی :</p>
                <ckeditor  :editor="editor" v-model="purpose" :config="editorConfig"></ckeditor>
            </v-col>
        </v-row>
        <div class="row mr-auto">
            <v-btn v-if="!customer" @click="submitForm" class="submit-btn">
                <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                ثبت تاریخچه
            </v-btn>
            <v-btn v-else @click="submitcustomer" class="submit-btn">
                <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                ثبت تاریخچه
            </v-btn>
        </div>
    </div>
</template>

<script>
import {Axios2} from "@/main";
import 'vue-persian-datetime-picker';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from "sweetalert2";


export default {
    name: "addHistory",
    props: {
        time: {
            default: ''
        },
        id: {
            default: ''
        },
        modal: {
            default: false
        },
        reload: {
            type:Function
        },
        customer: {
            default: false
        }
    },
    data() {
        return {
            title: '',
            step: '',
            remind_date: '',
            created_at: '',
            description: '',
            purpose: '',
            NowTime:[],
            editor: ClassicEditor,
            editorConfig: {
                language: 'fa',
                class: 'px-10'
            }
        }
    },
    methods: {
        submitForm() {
            this.$modal.showLoading();
            Axios2.post('user/history/estate', JSON.stringify({
                "estate_id": this.id,
                "title": this.title,
                "step": this.step,
                "remind_date": this.time,
                "created_at": this.created_at,
                "description": this.description,
                "purpose": this.purpose
            })).then(() => {
                this.$modal.hideLoading();
                this.$modal.success('موفقیت آمیز', 'تاریخچه مورد نظر با موفقیت ثبت شد.');
                this.reload();
                this.modal();
            }).catch((err) => {
                this.$modal.hideLoading();
                this.$modal.error('خطا!', '', Object.keys(err.response.data.errors).map((key) => {
                    return err.response.data.errors[key][0]
                }).join('\n'));
            })
        },
        submitcustomer() {
            this.$modal.showLoading();
            Axios2.post('user/history/customer', JSON.stringify({
                "customer_id": this.id,
                "title": this.title,
                "step": this.step,
                "remind_date": this.time,
                "created_at": this.created_at,
                "description": this.description,
                "purpose": this.purpose
            })).then(() => {
                this.$modal.hideLoading();
                this.$modal.success('موفقیت آمیز', 'تاریخچه مورد نظر با موفقیت ثبت شد.');
                this.modal();
            }).catch((err) => {
                this.$modal.hideLoading();
                this.$modal.error('خطا!');
            })
        },
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                type: 'GET',
                fn: this.getTimesForNow,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.NowTime = data.data.miladi;
                    this.created_at = data.data.miladi;
                }
            });
        }
    },
    watch:{
        time(value){
            if (value < this.NowTime){
                this.$modal.error('خطا در انتخاب زمان!','زمان انتخاب شده نمیتواند از زمان حال کمتر باشد.');
                this.time='';
            }
        }
    },
    mounted() {
        this.getTimesForNow();
    }
}
</script>

<style>

</style>